// extracted by mini-css-extract-plugin
module.exports = {"viewMoreButton":"TextViewMore_viewMoreButton___mz51","description":"TextViewMore_description__DSk0L","clampedText":"TextViewMore_clampedText__DhxEk"};